import { render } from "./VetHomeView.vue?vue&type=template&id=7d41b38c&scoped=true&ts=true"
import script from "./VetHomeView.vue?vue&type=script&lang=ts"
export * from "./VetHomeView.vue?vue&type=script&lang=ts"

import "./VetHomeView.vue?vue&type=style&index=0&id=7d41b38c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d41b38c"]])

export default __exports__